import React, { Component } from 'react';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import Preloader from '../../../GeneralComponents/LoadingComponen'
import ChatBoxCommentModules from '../../../GeneralComponents/ChatBoxCommentModules'

const chartCardOptions = {
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'bottom',
            labels: {
                boxWidth: 12,
                padding: 16,
                font: { size: 11, family: "'Inter', system-ui, sans-serif" },
                usePointStyle: true,
            },
        },
    },
};

const SummaryCard = ({ title, value, icon, color, subtitle }) => (
    <div className="col-md-3 col-sm-6 mb-3">
        <div
            className="tdash-stat h-100"
            style={{ '--tdash-accent': color }}
        >
            <div className="tdash-stat__glow" aria-hidden />
            <div className="tdash-stat__inner">
                <div className="tdash-stat__icon">
                    <i className={icon} />
                </div>
                <div className="tdash-stat__body">
                    <div className="tdash-stat__label">{title}</div>
                    <div className="tdash-stat__value">{value}</div>
                    {subtitle && <div className="tdash-stat__sub">{subtitle}</div>}
                </div>
            </div>
        </div>
    </div>
);

const ChartCard = ({ title, children, isLoaded, minHeight = 280 }) => (
    <div className="tdash-chart">
        <div className="tdash-chart__head">
            <span className="tdash-chart__title">{title}</span>
        </div>
        <div className="tdash-chart__body" style={{ minHeight }}>
            {isLoaded ? <Preloader /> : children}
        </div>
    </div>
);

class DashboardIndex extends Component {
    render() {
        const { summary, isLoaded } = this.props;

        return (
            <div className="tdash-root">
                <div className="tdash-ambient" aria-hidden>
                    <span className="tdash-ambient__b tdash-ambient__b--1" />
                    <span className="tdash-ambient__b tdash-ambient__b--2" />
                </div>

                <header className="tdash-hero">
                    <div className="tdash-hero__text">
                        <p className="tdash-hero__kicker">Centro de analítica</p>
                        <h1 className="tdash-hero__title">Dashboard de tareas</h1>
                        <p className="tdash-hero__desc">Resumen operativo, cumplimiento y distribución en un solo vistazo.</p>
                    </div>
                    {!isLoaded && summary && (
                        <div className="tdash-hero__chips">
                            <span className="tdash-chip"><strong>{summary.total || 0}</strong> totales</span>
                            <span className="tdash-chip tdash-chip--accent">{summary.completion_rate || 0}% completadas</span>
                        </div>
                    )}
                </header>

                {summary && !isLoaded && (
                    <div className="row tdash-stat-row">
                        <SummaryCard
                            title="Total tareas"
                            value={summary.total || 0}
                            icon="fas fa-layer-group"
                            color="#6366f1"
                        />
                        <SummaryCard
                            title="Pendientes"
                            value={summary.pendientes || 0}
                            icon="fas fa-hourglass-start"
                            color="#f59e0b"
                            subtitle="Sin iniciar"
                        />
                        <SummaryCard
                            title="En proceso"
                            value={summary.en_proceso || 0}
                            icon="fas fa-sync-alt"
                            color="#06b6d4"
                            subtitle="En desarrollo"
                        />
                        <SummaryCard
                            title="Finalizadas"
                            value={summary.finalizadas || 0}
                            icon="fas fa-check-circle"
                            color="#10b981"
                            subtitle={`${summary.completion_rate || 0}% del total`}
                        />
                    </div>
                )}

                {summary && !isLoaded && (
                    <div className="row tdash-stat-row">
                        <SummaryCard
                            title="Vencidas"
                            value={summary.vencidas || 0}
                            icon="fas fa-exclamation-circle"
                            color="#ef4444"
                        />
                        <SummaryCard
                            title="Próximas"
                            value={summary.proximas || 0}
                            icon="fas fa-bell"
                            color="#f97316"
                            subtitle="Menos de 5 días"
                        />
                        <SummaryCard
                            title="Vigentes"
                            value={summary.vigentes || 0}
                            icon="fas fa-calendar-check"
                            color="#22c55e"
                        />
                        <SummaryCard
                            title="Eficiencia"
                            value={`${summary.efficiency_rate || 0}%`}
                            icon="fas fa-chart-line"
                            color="#8b5cf6"
                            subtitle="A tiempo"
                        />
                    </div>
                )}

                <div className="row">
                    <div className="col-md-4">
                        <ChartCard title="Por estado" isLoaded={isLoaded}>
                            <Doughnut
                                data={this.props.state_tasks}
                                width={350}
                                height={280}
                                options={chartCardOptions}
                            />
                        </ChartCard>
                    </div>

                    <div className="col-md-4">
                        <ChartCard title="Por cumplimiento" isLoaded={isLoaded}>
                            <Doughnut
                                data={this.props.date_tasks}
                                width={350}
                                height={280}
                                options={chartCardOptions}
                            />
                        </ChartCard>
                    </div>

                    <div className="col-md-4">
                        <ChartCard title="Por tablero" isLoaded={isLoaded}>
                            <Doughnut
                                data={this.props.boards}
                                width={350}
                                height={280}
                                options={chartCardOptions}
                            />
                        </ChartCard>
                    </div>

                    <div className="col-md-7">
                        <ChartCard title="Por etiqueta" isLoaded={isLoaded} minHeight={300}>
                            <Bar
                                data={this.props.labels}
                                width={1189}
                                height={300}
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: { legend: { display: false } },
                                }}
                            />
                        </ChartCard>
                    </div>

                    <div className="col-md-5">
                        <ChartCard title="Creadas por mes" isLoaded={isLoaded} minHeight={300}>
                            <Line
                                data={this.props.monthly}
                                width={500}
                                height={300}
                                options={{
                                    maintainAspectRatio: false,
                                    scales: {
                                        yAxes: [{
                                            ticks: { beginAtZero: true }
                                        }]
                                    }
                                }}
                            />
                        </ChartCard>
                    </div>

                    <div className="col-md-12">
                        <ChartCard title="Por responsable" isLoaded={isLoaded} minHeight={300}>
                            <Bar
                                data={this.props.users}
                                width={1189}
                                height={300}
                                options={{
                                    maintainAspectRatio: false,
                                    plugins: { legend: { display: false } },
                                }}
                            />
                        </ChartCard>
                    </div>

                    <div className="col-md-12">
                        <ChatBoxCommentModules
                            users={this.props.usuarios}
                            module_name={"Dashboard"}
                            usuario={this.props.user}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default DashboardIndex;
